import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { findByAnoLetivoESerieCodSerie } from "../../Bimestre/api-bimestre";
import { dateFormat } from "../../../util/DateUtil";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import { mensagemDe } from "../cronogramaUtil";

/** Diálogo de cadastro/edição da quantidade de aulas de um bimestre. */
const CronogramaQuantAulaBimestreForm = ({ cqab, onClose, onSave, isSaving }) => {
  const [bimestres, setBimestres] = useState([]);
  const [codBimestre, setCodBimestre] = useState("");
  const [quantAulas, setQuantAulas] = useState("");
  const codSerie = cqab?.tdp?.turma?.serie?.codSerie;

  useEffect(() => {
    if (!cqab) return;
    setCodBimestre(cqab.bimestre?.codigo ?? "");
    setQuantAulas(cqab.quantAulas === null || cqab.quantAulas === undefined ? "" : String(cqab.quantAulas));
  }, [cqab]);

  useEffect(() => {
    if (!cqab || !codSerie) return;
    findByAnoLetivoESerieCodSerie(codSerie).then((data) => {
      if (Array.isArray(data)) {
        setBimestres([...data].sort((a, b) => (a.numeroBimestre ?? 0) - (b.numeroBimestre ?? 0)));
      } else if (data?.error) {
        errorMessage(mensagemDe(data));
      }
    });
  }, [cqab, codSerie]);

  const podeSalvar = codBimestre !== "" && quantAulas !== "" && !isSaving;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!podeSalvar) return;
    onSave({
      ...cqab,
      bimestre: bimestres.find((b) => b.codigo === codBimestre) ?? cqab.bimestre,
      quantAulas: Number(quantAulas),
    });
  };

  return (
    <Dialog open={Boolean(cqab)} onClose={onClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{cqab?.codigo ? "Editar Quantidade de Aulas" : "Nova Quantidade de Aulas"}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} pt={1}>
            <TextField
              select
              size="small"
              fullWidth
              required
              label="Bimestre"
              value={bimestres.some((b) => b.codigo === codBimestre) ? codBimestre : ""}
              onChange={(event) => setCodBimestre(event.target.value)}
              helperText={bimestres.length === 0 ? "Nenhum bimestre cadastrado para a série desta turma." : " "}
            >
              {bimestres.map((b) => (
                <MenuItem key={b.codigo} value={b.codigo}>
                  {b.numeroBimestre}º Bimestre
                  {b.dataInicio ? ` (${dateFormat(b.dataInicio)}${b.dataFim ? ` a ${dateFormat(b.dataFim)}` : ""})` : ""}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              size="small"
              fullWidth
              required
              label="Quantidade de aulas"
              value={quantAulas}
              onChange={(event) => setQuantAulas(event.target.value.replace(/\D/g, "").slice(0, 4))}
              slotProps={{ htmlInput: { inputMode: "numeric" } }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={!podeSalvar}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CronogramaQuantAulaBimestreForm;
